import { render, staticRenderFns } from "./BGModal.vue?vue&type=template&id=0bdd7ecb"
import script from "./BGModal.vue?vue&type=script&lang=js"
export * from "./BGModal.vue?vue&type=script&lang=js"
import style0 from "./BGModal.vue?vue&type=style&index=0&id=0bdd7ecb&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports